import React, {useEffect, useRef} from 'react';
import "./StepSide-bar.css";

const steps = [
    "Job Basics",
    "Compensation",
    "Job Description",
    "Media & Finalize",
];

export default function StepSidebar({ currentStep = 1, Submitted = false }) {
    const sidebarRef = useRef([]);

    useEffect(() => {
        const activeRef = sidebarRef.current[currentStep - 1];
        if (activeRef && activeRef.scrollIntoView) {
            activeRef.scrollIntoView({ behavior: "smooth", block: 'nearest', inline: 'center' });
        }
    }, [currentStep]);
    return (
        <aside className="create-job-sidebar">
            {steps.map((label, index) => {
                const stepP = index + 1;

                let statusClass

                if (Submitted) {
                    statusClass = "completed";
                } else if (stepP < currentStep) {
                    statusClass = "completed";
                } else if (stepP === currentStep) {
                    statusClass = "active";
                } else {
                    statusClass = "inactive";
                }

                const isLast = index === steps.length - 1;
                const isConnectedLineSolid = stepP < currentStep;

                return (
                    <div
                        key={label}
                        ref={(el) => (sidebarRef.current[index] = el)}
                        className={`create-job-step ${statusClass} ${isLast ? 'create-job-last-step' : ''}`}
                    >
                        <div className={`create-job-circle ${isConnectedLineSolid ? 'create-job-solid-line' : ''}`}>{stepP}</div>
                        <div className="create-job-step-text">{label}</div>
                    </div>
                );
            })}
        </aside>
    );
}